import { gql } from '@apollo/client';

import { TL2Category$L4Group } from 'Components/CategoryGroups/CategoryGroups.helpers';

type Category = {
  id: string;
  name: string;
  slug: string;
};

export type AvailableServicesResponse =
  | {
      l2BySlug: {
        id: string;
        l4Groups: {
          l2Id: string;
          name: string;
          l4Categories: Category[];
        }[];
      };
    }
  | {
      l3BySlug: { id: string; l4Categories: Category[] };
    };

export const availableServicesByL3Query = gql`
  query AvailableServicesByL3($slug: String!) {
    l3BySlug(slug: $slug) {
      id
      l4Categories {
        id
        name
        slug
      }
    }
  }
`;

export const availableServicesByL2Query = gql`
  query AvailableServicesByL2($slug: String!) {
    l2BySlug(slug: $slug) {
      id
      l4Groups {
        l2Id
        name
        l4Categories {
          id
          name
          slug
        }
      }
    }
  }
`;

export const extractCategoriesTree = (data: AvailableServicesResponse): TL2Category$L4Group[] => {
  let categories: TL2Category$L4Group[] = [];

  if ('l2BySlug' in data) {
    categories = data.l2BySlug.l4Groups;
  }
  if ('l3BySlug' in data) {
    categories = [
      {
        l4Categories: data.l3BySlug.l4Categories,
      },
    ];
  }
  return categories;
};
